module.exports = __webpack_public_path__ + "static/forget-it-960e360905bf9f00c6ffcca75d9766ca.mp3";